<template></template>

<script>
// Will create a <style> element for each "item" with the btn colors for use in OSpeedSelect
export default {
  name: "OCssClasses",
  props: {
    items: { type: Array, default: null },
    name: { type: String, default: "speedselect" },
    colorField: { type: String, default: "" },
  },
  methods: {
    lightOrDark(color) {
      // Variables for red, green, blue values
      var r, g, b, hsp;

      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );

        r = color[1];
        g = color[2];
        b = color[3];
      } else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        );

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
      }

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

      // Using the HSP value, determine whether the color is light or dark
      if (hsp < 157) {
        return "black";
      } else {
        return "white";
      }
    },
  },
  watch: {
    items: function () {
      const vm = this;
      if (this.colorField) {
        var css_text = "";
        _.forEach(this.items, function (o) {
          var text_color = vm.lightOrDark(o[vm.colorField]);

          css_text =
            css_text +
            ".btn-" +
            vm.name +
            o.id +
            "{background-color:" +
            o[vm.colorField] +
            "; color:" +
            text_color +
            ";border-color:" +
            o[vm.colorField] +
            ";} \n";
        });
        var css = document.createElement("style");
        css.type = "text/css";
        css.appendChild(document.createTextNode(css_text));
        document.body.appendChild(css);
      }
    },
  },
};
</script>

<style scoped></style>
